export const RCC_VALIDATION_EMPTY_FORMULA = -1;
export const RCC_VALIDATION_CRITICAL_LEVEL_AND_MANUAL = -2;
export const RCC_VALIDATION_WARNING_LEVEL_AND_MANUAL = -3;
export const RCC_VALIDATION_CRITICAL_LEVEL_AND_SPLIT = -4;
export const RCC_VALIDATION_WARNING_LEVEL_AND_SPLIT = -5;
export const RCC_VALIDATION_OK = 0;
export const RCC_VALIDATION_WARNING_LEVEL = 1;
export const RCC_VALIDATION_CRITICAL_LEVEL = 2;
export const RCC_VALIDATION_SPLIT_FORMULA = 3;
export const RCC_VALIDATION_MANUAL_COLORANT_ADDITION = 4;
export const RCC_VALIDATION_OVER_AVAILABLE_LEVEL = 5;
export const RCC_VALIDATION_MANUAL_COLORANT_ADDITION_CUSTOM_CAN = 6;
export const RCC_VALIDATION_MISSING_ITEM = 10;
export const RCC_VALIDATION_OTHER_ERROR = 20;

export const RCC_ICON_NO = 0;
export const RCC_ICON_INFORMATION = 1;
export const RCC_ICON_QUESTION = 2;
export const RCC_ICON_WARNING = 3;
export const RCC_ICON_ERROR = 4;

export const RCC_MESSAGE_WARNING_LEVEL = 105;
export const RCC_MESSAGE_WARNING_LEVELS = 106;
export const RCC_MESSAGE_CRITICAL_LEVEL = 107;
export const RCC_MESSAGE_CRITICAL_LEVELS = 108;
export const RCC_MESSAGE_PLACE_BASE_CAN = 110;
export const RCC_MESSAGE_DISPENSING_NO_BUTTONS = 116;
export const RCC_MESSAGE_DISPENSING = 117;
export const RCC_MESSAGE_QUICK_TINT_NO_BUTTONS = 118;
export const RCC_MESSAGE_QUICK_TINT = 119;
export const RCC_MESSAGE_VALIDATE_CAN = 121;
export const RCC_MESSAGE_VALIDATE_BASE_CAN = 122;
export const RCC_MESSAGE_FORMULA_OVERFILL_RULE_VOL = 129;
export const RCC_MESSAGE_RESET_ERRORS = 130;
export const RCC_MESSAGE_REFILL_CANISTER = 240;
export const RCC_MESSAGE_REFILL_CANISTER_AUTOTASK = 241;
export const RCC_MESSAGE_REFILL_CANISTER_BY_BARCODE = 243;
export const RCC_MESSAGE_REFILL_CANISTER_AUTOTASK_BY_BARCODE = 244;
export const RCC_MESSAGE_MANUAL_COLORANT_ADDITION = 312;
export const RCC_MESSAGE_MANUAL_DISPENSING = 313;
export const RCC_MESSAGE_FORMULA_OVERFILL_RULE_GRAV = 314;
export const RCC_MESSAGE_READ_BASE_UFI_CODE = 315;
export const RCC_MESSAGE_VALIDATE_BASE_UFI_CODE = 316;
export const RCC_MESSAGE_DISPENSE_CUSTOM_CAN_PREPARE_ADD_COLORANT = 317;
export const RCC_MESSAGE_DISPENSE_CUSTOM_CAN_PREPARE_ADD_COLORANTS = 318;
export const RCC_MESSAGE_DISPENSE_CUSTOM_CAN_ADD_COLORANT = 319;
export const RCC_MESSAGE_DISPENSE_CUSTOM_CAN_ADD_COLORANTS = 320;
export const RCC_MESSAGE_MEASURE_SELECT_MEASURE_MODE = 390;
export const RCC_MESSAGE_AUTOTASK_PURGE_START = 400;
export const RCC_MESSAGE_AUTOTASK_PURGE_START_FORCE = 401;
export const RCC_MESSAGE_AUTOTASK_BRUSH_MAINTENANCE_START = 405;
export const RCC_MESSAGE_AUTOTASK_BRUSH_MAINTENANCE_START_FORCE = 406;
export const RCC_MESSAGE_AUTOTASK_CAP_MAINTENANCE_START = 410;
export const RCC_MESSAGE_AUTOTASK_CAP_MAINTENANCE_START_FORCE = 411;
export const RCC_MESSAGE_AUTOTASK_SWITCH_PLATE_MAINTENANCE_START = 415;
export const RCC_MESSAGE_AUTOTASK_SWITCH_PLATE_MAINTENANCE_START_FORCE = 416;
export const RCC_MESSAGE_AUTOTASK_CLEANING_MAINTENANCE_START = 420;
export const RCC_MESSAGE_AUTOTASK_CLEANING_MAINTENANCE_START_FORCE = 421;
export const RCC_MESSAGE_AUTOTASK_REFILL_MAINTENANCE_START = 425;
export const RCC_MESSAGE_AUTOTASK_REFILL_MAINTENANCE_START_FORCE = 426;
export const RCC_MESSAGE_AUTOTASK_REBOOT_START = 430;
export const RCC_MESSAGE_AUTOTASK_REBOOT_START_FORCE = 431;
export const RCC_MESSAGE_AUTOTASK_SHUTDOWN_START = 435;
export const RCC_MESSAGE_AUTOTASK_SHUTDOWN_START_FORCE = 436;
export const RCC_MESSAGE_AUTOTASK_CLEAN_START = 440;
export const RCC_MESSAGE_AUTOTASK_CLEAN_START_FORCE = 441;
export const RCC_MESSAGE_AUTOTASK_RECIRCULATE_START = 445;
export const RCC_MESSAGE_AUTOTASK_RECIRCULATE_START_FORCE = 446;
export const RCC_MESSAGE_AUTOTASK_STIR_START = 450;
export const RCC_MESSAGE_AUTOTASK_STIR_START_FORCE = 451;
export const RCC_MESSAGE_AUTOTASKS = [
    400, 401, 405, 406, 410, 411, 415, 416, 420, 421, 425, 426, 430, 431, 435, 436, 440, 441, 445, 446, 450, 451
];
export const RCC_MESSAGE_COLOR_READER_CALIBRATIONS = [224, 225, 226, 227];

export const RCC_DEFAULT_PURGE_VOLUME = 1;
export const RCC_MINIMAL_PURGE_VOLUME = 0.25;
export const RCC_DEFAULT_CLEAN_TIME = 10;
export const RCC_MINIMAL_CLEAN_TIME = 5;
export const RCC_DEFAULT_RECIRCULATE_TIME = 30;
export const RCC_MINIMAL_RECIRCULATE_TIME = 5;
export const RCC_DEFAULT_RECIRCULATE_SPEED = 60;
export const RCC_DEFAULT_STIR_TIME = 30;
export const RCC_MINIMAL_STIR_TIME = 5;
export const RCC_DEFAULT_STIR_SPEED = 60;
export const RCC_DEFAULT_AUTOTASK_THRESHOLD = 0.9;

export const RCC_SENSOR_CAN = "can";
export const RCC_SENSOR_RECIRCULATION = "recirculation";
export const RCC_SENSOR_SHELF_MOVING_DOWN = "shelf_moving_down";
export const RCC_SENSOR_SHELF_MOVING_UP = "shelf_moving_up";
export const RCC_SENSOR_STIRRING = "stirring";
export const RCC_SENSOR_OFFLINE_PRESSED = "offline_pressed";
export const RCC_SENSOR_EMERGENCY_BTN_PRESSED = "emergency_btn_pressed";
export const RCC_LIST_OF_AVAILABLE_SENSORS = [
    RCC_SENSOR_CAN,
    RCC_SENSOR_RECIRCULATION,
    RCC_SENSOR_SHELF_MOVING_DOWN,
    RCC_SENSOR_SHELF_MOVING_UP,
    RCC_SENSOR_STIRRING,
    RCC_SENSOR_OFFLINE_PRESSED,
    RCC_SENSOR_EMERGENCY_BTN_PRESSED
];

export const RCC_BTN_YES = "yes";
export const RCC_BTN_NO = "no";
export const RCC_BTN_OK = "ok";
export const RCC_BTN_CANCEL = "cancel";
export const RCC_BTN_ABORT = "abort";
export const RCC_BTN_RETRY = "retry";
export const RCC_BTN_IGNORE = "ignore";
export const RCC_BTN_ALL = "all";
export const RCC_BTN_NO_TO_ALL = "not_to_all";
export const RCC_BTN_YES_TO_ALL = "yes_to_all";
export const RCC_BTN_SKIP = "skip";
export const RCC_BTN_CONTINUE = "continue";
export const RCC_BTN_HELP = "help";

export const RCC_REFILL = 1;
export const RCC_REFILL_MANUAL_CORRECTION = 2;

export const DISPENSING_LOGIC_AUTOMATIC = 1;
export const DISPENSING_LOGIC_FORCE_MANUAL_ADDITION = 2;
export const DISPENSING_LOGIC_FORCE_DISPENSING = 3;

export const SENSOR_STATE_LOW = 0;
export const SENSOR_STATE_STATE_HIGH = 1;
export const SENSOR_STATE_UNKNOWN = 2;

export const PROGRESS_CLEAN = "clean";
export const PROGRESS_DISPENSE = "dispense";
export const PROGRESS_ERRORS_RESET = "errors_reset";
export const PROGRESS_NONE = "none";
export const PROGRESS_PURGE = "purge";
export const PROGRESS_RECIRCULATE = "recirculate";
export const PROGRESS_RESET = "reset";
export const PROGRESS_STIR = "stir";

export const SHELF_UP = 0;
export const SHELF_DOWN = -1;
export const SHELF_PREFERENCE_PLATE = -2;
export const SHELF_NO_MOVE = -3;

export const CAP_CLOSE = 0;
export const CAP_OPEN = 1;
export const CAP_MIDDLE = 2;

export const RCC_MACHINE_SETTING_DISABLE = 0;
export const RCC_MACHINE_SETTING_ASK = 1;
export const RCC_MACHINE_SETTING_ENABLE = 2;

export const CONFIGURATION_GENERAL = "General";

export const DRIVER_TYPE_ALFA_REST_API = "AlfaRestApi";
export const DRIVER_TYPE_COROB_DS_PROXY = "CorobDspProxy";
export const DRIVER_TYPE_COROB_EVO_DRIVER = "CorobEvoDriver";
export const DRIVER_TYPE_COROB_NEXT_DRIVER = "CorobNextDriver";
export const DRIVER_TYPE_DROMONT_DDRV = "DromontDDRV";
export const DRIVER_TYPE_DROMONT_MISURA = "DromontMisura";
export const DRIVER_TYPE_DROMONT_V2 = "DromontV2";
export const DRIVER_TYPE_FLUID_IDD = "FluidIDD";
export const DRIVER_TYPE_FLUID_UIDD = "FluidUIDD";
export const DRIVER_TYPE_HERO = "Hero";
export const DRIVER_TYPE_ITALTINTO = "Italtinto";
export const DRIVER_TYPE_LLD = "LLD";
export const DRIVER_TYPE_MANUAL = "Manual";
export const DRIVER_TYPE_MANUAL_SIMPLE = "ManualSimple";
export const DRIVER_TYPE_NONE = "None";
export const DRIVER_TYPE_SANTINT = "Santint";
export const DRIVER_TYPE_SANTINT_DRIVER = "SantintDriver";
export const DRIVER_TYPE_SANTINT_JAVA = "SantintJava";
export const DRIVER_TYPE_SIMULATION = "Simulation";
export const DRIVER_TYPE_UDCP = "UDCP";

export const SPECTRO_TYPE_COLORIXCC3 = "ColorixCC3";
export const SPECTRO_TYPE_COLORIXNANO = "ColorixNano";
export const SPECTRO_TYPE_DATACOLOR = "Datacolor";
export const SPECTRO_TYPE_DATACOLORREADER = "DatacolorColorReader";
export const SPECTRO_TYPE_DATACOLORSELECT = "DatacolorSelect";
export const SPECTRO_TYPE_EYEONE = "EyeOne";
export const SPECTRO_TYPE_MINOLTA = "Minolta2XXX";
export const SPECTRO_TYPE_NIX = "Nix";
export const SPECTRO_TYPE_NIX_SPECTRO = "NixSpectro";
export const SPECTRO_TYPE_NIX_PRO = "NixPro";
export const SPECTRO_TYPE_NONE = "None";
export const SPECTRO_TYPE_SIMULATION = "Simulation";
export const SPECTRO_TYPE_XRITE = "XRite";

export const SPECTRO_TYPES_WITH_COM_PORT = [
    SPECTRO_TYPE_MINOLTA,
    SPECTRO_TYPE_NIX,
    SPECTRO_TYPE_NIX_SPECTRO,
    SPECTRO_TYPE_NIX_PRO,
    SPECTRO_TYPE_XRITE
];
export const SPECTRO_NOT_SELECTED = "Not selected";

export const MACHINE_DEVICE_CAN = "can";
export const MACHINE_DEVICE_CAP = "cap";
export const MACHINE_DEVICE_SHELF = "shelf";
export const MACHINE_DEVICE_PUNCHER = "puncher";
export const MACHINE_DEVICE_PLUGGER = "plugger";
export const MACHINE_DEVICE_MANUAL_PLUGGER = "manual_puncher";
export const MACHINE_DEVICE_HUMIDIFIER = "humidifier";
export const MACHINE_DEVICE_MOVABLE_TABLE = "movable_table";

export const CONFIG_BARCODE_REFILL = "barcode_refill";
export const CONFIG_BARCODE_REFILL_COLORANT_CHECK = "barcode_colorant_package_check";
export const CONFIG_BASE_CAN_BARCODE_VALIDATION = "base_can_barcode_validation";
export const CONFIG_BATCH_USE_LAST_REFILL = "batch_use_last_refill";
export const CONFIG_CHECK_CAN_BEFORE_DISPENSE = "check_can_before_dispense";
export const CONFIG_CHECK_OVERFILL = "check_overfill";
export const CONFIG_DISPENSE_INVALID_COLORANTS = "dispense_invalid_colorants";
export const CONFIG_MANUAL_COLORANT_ADDITION = "manual_colorant_addition";
export const CONFIG_MINIMAL_DISPENSE_AMOUNT = "minimal_dispense_amount";
export const CONFIG_PLACE_CAN_SENZOR = "place_can_sensor";
export const CONFIG_PLACE_CAN_SENZOR_DELAY = "place_can_sensor_delay";
export const CONFIG_READ_BASE_UFI_CODE = "read_base_ufi_code";
export const CONFIG_REMOVE_CAN_SENZOR = "remove_can_sensor";
export const CONFIG_REMOVE_CAN_SENZOR_DELAY = "remove_can_sensor_delay";
export const CONFIG_SKIP_PLACE_CAN_DIALOG = "skip_place_can_dialog";
export const CONFIG_SKIP_REMOVE_CAN_DIALOG = "skip_remove_can_dialog";
export const CONFIG_SPLIT_FORMULA = "spit_formula";
export const CONFIG_TMC_ENABLED = "tmc_enabled";
export const CONFIG_UFI_USE_LAST_REFILL = "ufi_use_last_refill";
export const CONFIG_UNIT = "unit";
export const CONFIG_VALIDATE_COLORANTS_DURING_INIT = "validate_colorants_during_init";

export const CONSUMPTION_TYPE_PURGE = "purge";
export const CONSUMPTION_TYPE_DISPENSE = "dispense";
export const CONSUMPTION_TYPE_ALL = "all";

export const SPECTRO_MODE_45 = "45/0";
export const SPECTRO_MODE_EGGSHELL = "Eggshell";
export const SPECTRO_MODE_FLAT = "Flat";
export const SPECTRO_MODE_GLOSS = "Gloss";
export const SPECTRO_MODE_MATT = "Matt";
export const SPECTRO_MODE_MATTE = "Matte";
export const SPECTRO_MODE_PEARL = "Pearl";
export const SPECTRO_MODE_SATIN = "Satin";
export const SPECTRO_MODE_SEMI_GLOSS = "Semi-Gloss";
